import React from "react";
import { ExperienceItemType } from "components/molecules/experience-item/ExperienceItem";
import ExperienceItem from "components/molecules/experience-item";
import "./experience.scss";
import IconText from "components/atoms/icon-text";
import { IconTextType } from "components/atoms/icon-text/IconText";
import { FaJava } from "react-icons/fa";
import { DiJavascript1, DiDart } from "react-icons/di";
import { AiOutlineConsoleSql } from "react-icons/ai";
import { SiDotnet, SiTypescript } from "react-icons/si";

export const Experience = () => {
  return (
    <section id="experience" className="experience">
      <div className="row row-center">
        <div className="col-md-6">
          <div className="__title">
            <h1 className="__title__bold">Skills</h1>
            <h1 className="__title__normal">& Experience</h1>
          </div>
          <div className="__msg">
            <hr />
            <p>
              Experienced Software Developer with a demonstrated history of
              working in the banking and business industries. Skilled in Public
              Speaking, Flutter, Java, DotNetCore, JavaScript and Typescript.
              Strong engineering professional graduated from ITLA and some
              certifications focused on development skills of ReactJS,
              Angular2+, Java Spring Boot, Flutter, C# DotNetCore and others.
            </p>
          </div>
          <div className="experience__skills_container">
            <h3>Skills</h3>
            <div className="experience__skills">
              {skillItems.map((item: IconTextType) => (
                <div key={'container-' + item.id} className="experience_skills_item">
                  <IconText key={item.id} {...item}  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <h3 className="experience__list__title">Experience</h3>
          <div className="experience__list__container row justify-content-center p-2">
            {experienceItems.map((item) => (
              <ExperienceItem key={item.id} {...item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const experienceItems: ExperienceItemType[] = [
  {
    id: 102,
    title: "Full-stack Software Developer",
    subTitle: "LABORATIO, LLC",
    startDate: 2021,
    endDate: "Present",
    jobType: "Part-time",
  },
  {
    id: 101,
    title: "Software Engineer Team Lead",
    subTitle: "Newtech - Verizon",
    startDate: 2020,
    endDate: "Present",
    jobType: "Full-time",
  },
  {
    id: 100,
    title: "Software Developer Analyst",
    subTitle: "Soluciones Scotiabank",
    startDate: 2019,
    endDate: 2020,
    jobType: "Full-time",
  },
];

const skillItems: IconTextType[] = [
  {
    id: 1,
    text: "Java",
    borderRadious: 1.5,
    icon: <FaJava />,
  },
  {
    id: 11,
    text: "C# .Net",
    borderRadious: 1.5,
    icon: <SiDotnet />,
  },
  {
    id: 4,
    text: "SQL",
    borderRadious: 1.5,
    icon: <AiOutlineConsoleSql />,
  },
  {
    id: 2,
    text: "Javascript",
    borderRadious: 1.5,
    icon: <DiJavascript1 />,
  },
  {
    id: 5,
    text: "Typescript",
    borderRadious: 1.5,
    icon: <SiTypescript />,
  },
  {
    id: 3,
    text: "Dart",
    borderRadious: 1.5,
    icon: <DiDart />,
  },
  
  
];
